import { combineReducers } from 'redux';
import dropdown from './dropdown/dropdown';
import navigationOptions from './navigationOptions/navigationOptions';
import userInfo from '../shared/reducers/userInfo/userInfo';

export default combineReducers({
    dropdown,
    navigationOptions,
    userInfo,
});
